import React from "react";
import loginService from '../services/login';
import loginAdminService from '../services/adminLogin';
import Cookies from 'universal-cookie';
import getCurrentConfigurazione from "../services/getCurrentConfigurazione";

var UserStateContext = React.createContext();
var UserDispatchContext = React.createContext();
const qs = require('querystring');

function userReducer(state, action) {
  switch (action.type) {
    case "LOGIN_SUCCESS":
      return { ...state, isAuthenticated: true };
      case "LOGIN_FAILURE":
        return { ...state, isAuthenticated: false };
      case "SIGN_OUT_SUCCESS":
      return { ...state, isAuthenticated: false };
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

function UserProvider({ children }) {
  var [state, dispatch] = React.useReducer(userReducer, {
    isAuthenticated: !!localStorage.getItem("id_token"),
  });

  return (
    <UserStateContext.Provider value={state}>
      <UserDispatchContext.Provider value={dispatch}>
        {children}
      </UserDispatchContext.Provider>
    </UserStateContext.Provider>
  );
}

function useUserState() {
  var context = React.useContext(UserStateContext);
  if (context === undefined) {
    throw new Error("useUserState must be used within a UserProvider");
  }
  return context;
}

function useUserDispatch() {
  var context = React.useContext(UserDispatchContext);
  if (context === undefined) {
    throw new Error("useUserDispatch must be used within a UserProvider");
  }
  return context;
}

export { UserProvider, useUserState, useUserDispatch, loginUser, adminSignOut, signOut, loginAdminUser };

// ###########################################################

async function loginUser(dispatch, login, password, db, history, setIsLoading, setError) {
  setError(false);
  setIsLoading(true);
  if (!!login && !!password) {

    const resp = await loginService(login, password, db);
    if (resp.user === null || resp.token === null) {
      dispatch({ type: "LOGIN_FAILURE" });
      setError(true);
      setIsLoading(false);
    } else {

      const cookies = new Cookies();
      cookies.set('token', resp.token, { path: '/' });
      cookies.set('username', resp.user.username, { path: '/' });
      cookies.set('adminId', resp.user.id, { path: '/' });
      cookies.set('userType', parseInt(resp.user.type), { path: '/' });

      const configurazioneAttuale = await getCurrentConfigurazione(resp.user.username, resp.token, db);
      if(configurazioneAttuale.result == 'ok') {
        cookies.set('mainColor', configurazioneAttuale.configurazioni.mainColor.substring(1), { path: '/' });
        cookies.set('secondaryColor', configurazioneAttuale.configurazioni.secondaryColor.substring(1), { path: '/' });
        window.sessionStorage.setItem('logo', configurazioneAttuale.configurazioni.logoUrl);
        window.sessionStorage.setItem('primary_color', configurazioneAttuale.configurazioni.mainColor);
        window.sessionStorage.setItem('secondary_color', configurazioneAttuale.configurazioni.secondaryColor);
      } else {
        cookies.set('mainColor', 'F58320', { path: '/' });
        cookies.set('secondaryColor', 'FFC260', { path: '/' });
      }

      window.sessionStorage.setItem('user_type', parseInt(resp.user.type))

      setError(null)
      dispatch({ type: 'LOGIN_SUCCESS' });
      
      const parsed = qs.parse(window.location.hash);
        let id = parsed['#/login?esame']
        if (!id) {
          window.location.href = '/' + cookies.get('db', {path: '/' }) + '/#/app/dashboard';
          return;
        }
        window.location.href = '/' + cookies.get('db', {path: '/' }) + "/#/app/infoTest?id=" + id;

    }
  } else {
    dispatch({ type: "LOGIN_FAILURE" });
    setError(true);
    setIsLoading(false);
  }
}


async function loginAdminUser(dispatch, login, password, history, setIsLoading, setError) {
  setError(false);
  setIsLoading(true);

  if (!!login && !!password) {

    const resp = await loginAdminService(login, password);
    if (resp.user === null || resp.token === null){
      dispatch({ type: "LOGIN_FAILURE" });
      setError(true);
      setIsLoading(false);
    }
    else {

      const cookies = new Cookies();
      cookies.set('token', resp.token, { path: '/' });
      cookies.set('username', resp.user.username, { path: '/' });
      cookies.set('mode', 'sys-admin', { path: '/' });

      setError(null)
      dispatch({ type: 'LOGIN_SUCCESS' });
      window.location.href = '#/admin/clients';

      history.push('/admin/clients')
    }
  } else {
    dispatch({ type: "LOGIN_FAILURE" });
    setError(true);
    setIsLoading(false);
  }
}

function adminSignOut(dispatch, history) {
  const cookies = new Cookies();
  cookies.set('token', '', { path: '/' });
  cookies.set('currentEventName', '', { path: '/' });
  cookies.set('mode', '', { path: '/' });
  cookies.set('username', '', { path: '/' });
  dispatch({ type: "SIGN_OUT_SUCCESS" });
  window.location.href = '/admin';
}

function signOut(dispatch, history) {
  const cookies = new Cookies();
  cookies.set('token', '', { path: '/' });
  cookies.set('currentEventName', '', { path: '/' });
  cookies.set('mode', '', { path: '/' });
  cookies.set('username', '', { path: '/' });
  window.sessionStorage.setItem('user_type', '');
  dispatch({ type: "SIGN_OUT_SUCCESS" });
  window.location.href = '/' + cookies.get('db', { path: '/' }) + '#/login';
}
